export const actionTypes = {
  FETCH_ALBUMS_AND_USERS_PENDING: "FETCH_ALBUMS_AND_USERS_PENDING",
  FETCH_ALBUMS_AND_USERS_SUCCESS: "FETCH_ALBUMS_AND_USERS_SUCCESS",
  FETCH_ALBUMS_AND_USERS_FAILED: "FETCH_ALBUMS_AND_USERS_FAILED",
  FETCH_ALBUM_DETAILS_PENDING: "FETCH_ALBUM_DETAILS_PENDING",
  FETCH_ALBUM_DETAILS_SUCCESS: "FETCH_ALBUM_DETAILS_SUCCESS",
  FETCH_ALBUM_DETAILS_FAILED: "FETCH_ALBUM_DETAILS_FAILED",
};
